/* unplugin-vue-components disabled */import { render } from "./header.vue?vue&type=template&id=f3952604&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=f3952604&lang=css"
import "./header.vue?vue&type=style&index=1&id=f3952604&scoped=true&lang=css"

import exportComponent from "D:\\un-app\\ys_wuxie_webview_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3952604"]])

export default __exports__